import _classCallCheck from "/app/node_modules/babel-runtime/helpers/classCallCheck";
export var OnHoldError = function OnHoldError(_ref) {
  var message = _ref.message,
      platformRecordId = _ref.platformRecordId;

  _classCallCheck(this, OnHoldError);

  this.message = message;
  this.platformRecordId = platformRecordId;
};


//////////////////
// WEBPACK FOOTER
// ./src/api/errors/on-hold.js
// module id = ./src/api/errors/on-hold.js
// module chunks = 34